module.exports = {"pageTitleText":"Support"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/en-US/support.json
// module id = lA41
// module chunks = 3